import { render, staticRenderFns } from "./CustomReportWrapper.vue?vue&type=template&id=c6bd208c"
import script from "./CustomReportWrapper.vue?vue&type=script&lang=js"
export * from "./CustomReportWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports